module.exports = __webpack_public_path__ + "static/img/cover_gxy.jpg";